var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeads(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3.40426,
    transform: "matrix(-1 0 0 1 12.2127 8.40426)",
    stroke: "#98A2B3",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25531 16.8594C6.25531 16.1272 6.71561 15.474 7.40517 15.2277V15.2277C10.5141 14.1174 13.9114 14.1174 17.0203 15.2277V15.2277C17.7099 15.474 18.1702 16.1272 18.1702 16.8594V17.979C18.1702 18.9896 17.2751 19.7659 16.2747 19.6229L15.9412 19.5753C13.4681 19.222 10.9574 19.222 8.48436 19.5753L8.15081 19.6229C7.15038 19.7659 6.25531 18.9896 6.25531 17.979V16.8594Z",
    stroke: "#98A2B3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3192 11.9028C18.7964 11.9028 19.9939 10.7052 19.9939 9.22799C19.9939 7.75076 18.7964 6.55322 17.3192 6.55322",
    stroke: "#98A2B3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2486 18.0051L20.5107 18.0425C21.2967 18.1548 22 17.5448 22 16.7508V15.8711C22 15.2958 21.6383 14.7826 21.0965 14.5891C20.5561 14.3961 20.0045 14.2458 19.4468 14.1382",
    stroke: "#98A2B3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68085 11.9028C5.20361 11.9028 4.00607 10.7052 4.00607 9.22799C4.00607 7.75076 5.20361 6.55322 6.68085 6.55322",
    stroke: "#98A2B3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7514 18.0051L3.48932 18.0425C2.70327 18.1548 2 17.5448 2 16.7508V15.8711C2 15.2958 2.36167 14.7826 2.90347 14.5891C3.44392 14.3961 3.99546 14.2458 4.55319 14.1382",
    stroke: "#98A2B3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/Leads.355ab91596c95f797e6f4c1e2be3c407.svg";
export { ForwardRef as ReactComponent };